import React, {Component} from 'react';
// import CustomIconsAgGrid from "../DealroomFinStr/CustomIconsAgGrid";
import SimpleInputAgGridRenderer
  from "../DealroomFinStr/SimpleInputAgGridRenderer";
import SimpleInputAgGridEditor
  from "../../../FinancicalStructure/FinancicalStructure/FieldRenderer/SimpleInputAgGridEditor";
import CheckboxAgGridEditor from "../../../FinancicalStructure/FinancicalStructure/FieldRenderer/CheckboxAgGridEditor";
import ColDef from "ag-grid-community";
import {AgGridReact} from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import {setDealRoomFinSchemaErrors, emptyEditFinStructure} from "../../../../store/actions";
import {connect} from "react-redux";
import {rowAndColDefination} from "../DealroomFinStr/helpers";

class DealroomFinStr extends Component {

  state = {
    rowData: [],
    colDef: [],
    frameworkComponents: {
      // customIcons: (params) => <CustomIconsAgGrid params={params}/>,
      simpleInputAgGridRenderer: SimpleInputAgGridRenderer,
      simpleInputAgGridEditor: SimpleInputAgGridEditor,
      checkboxAgGridEditor: CheckboxAgGridEditor,
    },
    cellRendererSelector: ColDef,
    cellEditorSelector: ColDef,
  };

  componentDidMount() {
    const {emptyEditFinStructure, financial_structure,finStrIndex,scenarioFinStrDataChange} = this.props;

    emptyEditFinStructure();
    const {rowObj,colDef} = rowAndColDefination(financial_structure,finStrIndex,true);
    scenarioFinStrDataChange(rowObj);
    this.setState({rowData: [rowObj], colDef,currentValues:rowObj});
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {financial_structure,finStrIndex,scenarioFinStrDataChange} = this.props;

    if (financial_structure.id !== prevProps.financial_structure.id) {
      const {rowObj,colDef} = rowAndColDefination(financial_structure,finStrIndex,true);
      scenarioFinStrDataChange(rowObj);
      this.setState({rowData: [rowObj], colDef,currentValues:rowObj});
    }
  }

  render() {
    const {colDef, rowData, frameworkComponents} = this.state;
    const {onFinStrChoose,finStrIndex,setDealRoomFinSchemaErrors,scenarioFinStrDataChange} = this.props;

    return (
      <React.Fragment>
        <div
          className="ag-theme-material"
          style={{
            height: "120px",
            width: "100%",
            marginTop: "50px",
            border: '2px solid rgb(225, 150, 96)'

          }}
        >
          <div style={{height: '120px'}}>
            <AgGridReact
              enableSorting={true}
              enableFilter={true}
              columnDefs={colDef}
              rowData={rowData}
              scenarioFinStrDataChange={scenarioFinStrDataChange}

              onFinStrChoose={onFinStrChoose}
              singleClickEdit={true}
              rowSelection="single"
              setDealRoomFinSchemaErrors={setDealRoomFinSchemaErrors}
              frameworkComponents={frameworkComponents}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default connect(null, {emptyEditFinStructure,setDealRoomFinSchemaErrors})(DealroomFinStr);


// WEBPACK FOOTER //
// ./src/views/Dealroom/Dealroom/ScenarioFinStr/index.js